<template>
    <b-modal
      v-model="open"
      centered
      hide-header
      hide-footer
      size="xl"
      @hidden="$emit('close')"
    >
      <div class="content-container">
        <iframe 
          :src="this.memberUrl + '/embed/agreement/cod-agreement?token=' + memberServiceToken"
          width="100%"
          height="100%"
          allow="clipboard-write"
        >
        </iframe>
      </div>
    </b-modal>
</template>

<script>
    export default {
        name: "ModalCodAgreement",
        props: {
            open: Boolean,
            memberServiceToken: String
        },
        data() {
            return {
                memberUrl: process.env.VUE_APP_MEMBER_SERVICE_API || '',
            }
        },
        methods: {
            handleIframeMessage(event) {
                if (event.data.eventType === 'cod-agreement') {
                    if (event.data.data.action === 'cancel' || event.data.data.action === 'submit') {
                        this.$emit('close');
                    }
                }
            },
        },
        watch: {
            open(val) {
                if (val) {
                    window.addEventListener("message", this.handleIframeMessage);
                } else {
                    window.removeEventListener("message", this.handleIframeMessage);
                }
            },
        },
        beforeDestroy() {
            // Cleanup to prevent memory leaks
            window.removeEventListener("message", this.handleIframeMessage);
        },
    }
</script>

<style scoped>
    .content-container {
        height: 800px;
    }

    @media (max-width: 500px) {
        .content-container {
            height: 550px;
        }
    }
</style>